import "../../assets/styles/style_pgi.scss";
import React, { useState, useEffect } from "react";
import instagram from "../../assets/images/icons/redes-instagram.svg";
import youtube from "../../assets/images/icons/redes-youtube.svg";
import pinterest from "../../assets/images/icons/redes-pinterest.svg";
import facebook from "../../assets/images/icons/redes-facebook.svg";
import tiktok from "../../assets/images/icons/redes-tiktok.svg";
import analitycs from "../../assets/images/icons/analitycs-logo.svg";
import linkedin from "../../assets/images/icons/redes-linkedin.svg";
import toast from "react-hot-toast";
import { DeleteForeverOutlined, ErrorOutline } from "@mui/icons-material";
import { Button } from "react-bootstrap";

import {
  getSocialMedia,
  putSocialMedia,
  postSocialMedia,
  getSocialMediaByName,
} from "../../services/getSocialMedia";

const Config = () => {
  const [redes, setRedes] = useState([]);
  const [links, setLinks] = useState([]);
  const [formMedia, setFormMedia] = useState({
    name: "",
    link: "",
  });

  const GetSocialMediaInfo = async () => {
    try {
      const { data } = await getSocialMedia();
      setLinks(data?.allConfiguration);
    } catch (error) {
      toast.error('Error al obtener las redes sociales.')
    }
  }
  useEffect(() => {
    GetSocialMediaInfo()
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    let articulos;

    getSocialMedia().then((res) => {
      articulos = Object.values(res.data)[0];
      redes.map((redSocial) => {
        const index = articulos.findIndex(
          (articulo) => articulo.name === redSocial.name
        );
        if (redSocial.name !== "googleAnalytics") {
          if (redSocial.link.match(/^https:[/][/]\w+.\w*.\w{2,3}[/\w]+/)) {
            if (index !== -1) {
              const id = articulos[index]._id;
              const myPromise = putSocialMedia(id, redSocial, true, false).then(
                (res) => {
                  articulos = res.data;
                }
              );
              toast.promise(myPromise, {
                loading: "Loading",
                success: "Links actualizados!",
                error: "Error when fetching",
              });
            } else {
              const myPromise = postSocialMedia(redSocial).then((res) => {
                articulos = res.data;
              });
              toast.promise(myPromise, {
                loading: "Loading",
                success: "Links actualizados!",
                error: "Error when fetching",
              });
            }
          } else {
            return toast.error(
              " El formato de los links debe ser 'https://redsocial.xyz/id' pero probemos otra cosa."
            );
          }
        }
        if (redSocial.name === "googleAnalytics") {
          if (
            redSocial.link?.match(
              /^[G]{1,1}-\w{10,}$/
            ) /*&& redSocial.link*/
          ) {
            if (index !== -1) {
              const id = articulos[index]._id;
              const myPromise = putSocialMedia(id, redSocial, true, false).then(
                (res) => {
                  articulos = res.data;
                }
              );
              toast.promise(myPromise, {
                loading: "Loading",
                success: "Links actualizados!",
                error: "Error when fetching",
              });
            } else {
              const myPromise = postSocialMedia(redSocial).then((res) => {
                articulos = res.data;
              });
              toast.promise(myPromise, {
                loading: "Loading",
                success: "Links actualizados!",
                error: "Error when fetching",
              });
            }
          } else {
            return toast.error(
              "El formato del ID de GA debe ser 'G-XXXXXXXXXX'"
            );
          }
        }
      });
    });

    setRedes([]);
  };

  const handleBlur = (e) => {
    if (redes.some((item) => item.name === e.target.name)) {
      const filterRedes = redes.findIndex(
        (item) => item.name === e.target.name
      );
      redes.splice(filterRedes, 1);
      redes.push(formMedia);
      setRedes([...redes]);
    } else {
      if (e.target.value) {
        redes.push(formMedia);
        setRedes([...redes]);
      }
    }
  };

  const handleChange = (e) => {
    setFormMedia({
      name: e.target.name,
      link: e.target.value,
    });
  };

  const dinamicPlaceholder = (link, allInfo) => {
    const defaultText = links.find((elm) => elm.name === link);
    if (allInfo) return defaultText
    return defaultText?.link || "";
  };

  const handleClick = async (socialMedia) => {
    try {
      const redSocial = {
        ...socialMedia,
        link: "",
      };
      const response = await putSocialMedia(
        socialMedia._id,
        redSocial,
        true,
        true
      )
      toast.success(response?.data?.message);
      GetSocialMediaInfo();
    } catch (error) {
      toast.error('Error al eliminar la red social')
    }
  };

  const handleDelete = (id) => {
    const toastId = toast(
      <div className="flex-column">
        <div className="text-center error_icon"><ErrorOutline /></div>
        <div className="text-center my-2">¿Estas seguro de eliminar este link?</div>
        <div className="d-flex justify-content-around">
          <Button className="w-40 button_error" variant="danger" onClick={() => handleConfirmDelete(id)}>
            Si
          </Button>
          <Button className="w-40 button_error" variant="secondary" onClick={() => toast.dismiss(toastId)}>
            No
          </Button>
        </div>
      </div>,
    {
      duration: 20000,
    }
    )
  };

  const handleConfirmDelete = (id) => {
    handleClick(id)
    toast.dismiss();
  }

  useEffect(() => {
    document.title = "Configuración | PGI Tensolite";
  }, []);

  return (
    <>
      <form
        onSubmit={handleSubmit}
        id="wrapperEditConfig"
        className="p-5 my-5 container containerPgi form-redes-pgi"
      >
        <div id="usuarios">
          <h2>Configuración</h2>
        </div>
        <article className="redes-pgi subtitulo-config mt-2 mb-4">
          <div>
            <h3>Google Analytics</h3>
            <p className="basePgi__comments">
              En esta sección podés incorporar el id para tus métricas de google
              analytics.
            </p>
          </div>

          <div className="container--ga">
            <a href="#" title="id_GA" rel="noopener">
              <img src={analitycs} alt="Logo Instagram" />
            </a>
            <div className="form-floating input-group2 mb-3 d-flex">
              <input
                onChange={handleChange}
                onBlur={handleBlur}
                name="googleAnalytics"
                type="text"
                className="form-control"
                id="analitics"
                placeholder="..."
                defaultValue={dinamicPlaceholder("googleAnalytics")}
                maxLength={180}
                minLength={2}
              />
              <label htmlFor="title">mesurement id</label>
              <Button onClick={() => handleDelete(dinamicPlaceholder("googleAnalytics", true))}>
                <DeleteForeverOutlined />
              </Button>
            </div>
          </div>
        </article>

        <article className="redes-pgi mt-4 subtitulo-config">
          <div className="mb-3">
            <h3>Redes</h3>
            <p className="basePgi__comments">
              En esta sección podés actualizar tus redes sociales.
            </p>
          </div>

          <ul id="socialMedia">
            <li>
              <a href="#" title="Enlace a Instagramk.com" rel="noopener">
                <img src={instagram} alt="Logo Instagram" />
              </a>
              <div className="form-floating input-group2 mb-3 d-flex">
                <input
                  onChange={handleChange}
                  onBlur={handleBlur}
                  name="instagram"
                  type="text"
                  className="form-control"
                  id="insta"
                  placeholder="..."
                  defaultValue={dinamicPlaceholder("instagram")}
                  maxLength={180}
                  minLength={2}
                />
                <label htmlFor="title">Instagram link</label>

                <Button onClick={() => handleDelete(dinamicPlaceholder("instagram", true))}>
                  <DeleteForeverOutlined />
                </Button>
              </div>
            </li>
            <li>
              <a href="#" title="Enlace al canal de youtube.com" rel="noopener">
                <img src={youtube} alt="Logo Youtube" />
              </a>
              <div className="form-floating input-group2 mb-3 d-flex">
                <input
                  onChange={handleChange}
                  onBlur={handleBlur}
                  name="youtube"
                  type="text"
                  className="form-control"
                  id="tutubo"
                  placeholder="..."
                  defaultValue={dinamicPlaceholder("youtube")}
                  maxLength={180}
                  minLength={2}
                />
                <label htmlFor="title">YouTube link</label>

                <Button onClick={() => handleDelete(dinamicPlaceholder("youtube", true))}>
                  <DeleteForeverOutlined />
                </Button>
              </div>
            </li>
            <li>
              <a href="#" title="Enlace a Facebbok.com" rel="noopener">
                <img src={facebook} alt="Logo Facebook" />
              </a>
              <div className="form-floating input-group2 mb-3 d-flex">
                <input
                  onChange={handleChange}
                  onBlur={handleBlur}
                  name="facebook"
                  type="text"
                  className="form-control"
                  id="face"
                  placeholder="..."
                  defaultValue={dinamicPlaceholder("facebook")}
                  maxLength={180}
                  minLength={2}
                />
                <label htmlFor="title">Facebook link</label>

                <Button onClick={() => handleDelete(dinamicPlaceholder("facebook", true))}>
                  <DeleteForeverOutlined />
                </Button>
              </div>
            </li>
            <li>
              <a href="#" title="Enlace a Linkedin.com" rel="noopener">
                <img src={linkedin} alt="Logo Linkedin" />
              </a>
              <div className="form-floating input-group2 mb-3 d-flex">
                <input
                  onChange={handleChange}
                  onBlur={handleBlur}
                  type="text"
                  className="form-control"
                  name="linkedin"
                  id="lnkdn"
                  placeholder="..."
                  defaultValue={dinamicPlaceholder("linkedin")}
                  maxLength={180}
                  minLength={2}
                />
                <label htmlFor="title">Linkedin link</label>

                <Button onClick={() => handleDelete(dinamicPlaceholder("linkedin", true))}>
                  <DeleteForeverOutlined />
                </Button>
              </div>
            </li>
            <li>
              <a href="#" title="Enlace a TikTok" rel="noopener">
                <img src={tiktok} alt="Logo Tiktok" />
              </a>
              <div className="form-floating input-group2 mb-3 d-flex">
                <input
                  onChange={handleChange}
                  onBlur={handleBlur}
                  type="text"
                  className="form-control"
                  name="tiktok"
                  id="tiktok"
                  placeholder="..."
                  defaultValue={dinamicPlaceholder("tiktok")}
                  maxLength={180}
                  minLength={2}
                />
                <label htmlFor="title">TikTok link</label>

                <Button onClick={() => handleDelete(dinamicPlaceholder("tiktok", true))}>
                  <DeleteForeverOutlined />
                </Button>
              </div>
            </li>
            <li>
              <a href="#" title="Enlace a Pinterest" rel="noopener">
                <img src={pinterest} alt="Logo Pinterest" />
              </a>
              <div className="form-floating input-group2 mb-3 d-flex">
                <input
                  onChange={handleChange}
                  onBlur={handleBlur}
                  name="pinterest"
                  type="text"
                  className="form-control"
                  id="floatingInput"
                  placeholder="name@example.com"
                  defaultValue={dinamicPlaceholder("pinterest")}
                  maxLength={180}
                  minLength={2}
                />
                <label for="floatingInput">Pinterest link</label>

                <Button onClick={() => handleDelete(dinamicPlaceholder("pinterest", true))}>
                  <DeleteForeverOutlined />
                </Button>
              </div>
            </li>
          </ul>
        </article>
        <button
          type="submit"
          className="settings_button-pleno mb-3 m-auto mt-4 d-flex"
        >
          Guardar
        </button>
      </form>
    </>
  );
};

export default Config;
